module.exports = __webpack_public_path__ + "img/yangDetail2.447aaae8.jpg";